/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */
import { loadAnalyticsConfig } from './analyticsConfig.js';
let started = false;

function start() {
  if (started) return;
  started = true;
  Promise.all([loadAnalyticsConfig(), import('posthog-js')]).then(([cfg, { default: posthog }]) => {
    if (!cfg.enabled || !cfg.api_key) return;
    posthog.init(cfg.api_key, {
      api_host: cfg.host || 'https://us.i.posthog.com',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
      cross_subdomain_cookie: true,
      autocapture: cfg.autocapture !== false,
      disable_session_recording: !cfg.session_recording,
      session_recording: { maskAllInputs: true },
    });
    posthog.register({ site_area: 'marketing' });
  }).catch(() => { started = false; });
}

export function initPosthog() {
  if (typeof window === 'undefined') return;
  const consent = window.SeqConsent;
  if (!consent || consent.allowed('stat')) start();
  if (consent) consent.onChange((c) => { if (c.stat) start(); });
}
